$(document).ready(function() {
	if(!document.querySelector('.support-help-library')) return false;
	

	var supportHelpLibrary = function() {
		var cont = $('.support-help-library'),
			isSolution = false,
			helpLibraryData;

		// no-data content hidden
		// cont.find('.no-content').hide();
		// cont.find('.error-common').hide();

		// if Solution page
		if(cont.hasClass('no-snb-type')) isSolution = true;

		var tabs,
			url,
			max,
			product,
			sort,
			topic;

		var callHelpLibrary = function() {
			var dataTemp;
			var symData={
					"sym_name":null,
					"url":null
			} ;
			
			if(isSolution) {
				// solution
				tabs = cont.find('.tabs-type-liner');
				url = tabs.data('url');
				max = tabs.data('max');
				sort = tabs.find('.btn-tab.active').data('sort');
				topic = tabs.data('topic');

				if(!topic) topic="";

				var cate = tabs.data('category'),
					supercate = tabs.data('supercategory');
				
				
				if(url.indexOf('?') != -1) {
					
					url = url+'&sort='+sort+'&categoryId='+cate+'&superCategoryId='+supercate+'&topic='+topic+'&limit='+max;
				} else {
					url = url+'?sort='+sort+'&categoryId='+cate+'&superCategoryId='+supercate+'&topic='+topic+'&limit='+max;
				}
				
				symData.sym_name=topic;
				symData.url=url;
			} else {
				// psp
				tabs = cont.find('.tabs-menu-wrapper');
				url = tabs.data('url');
				max = tabs.data('max');
				product = tabs.data('product');
				sort = tabs.data('sort');
				
				url = url+'?sort='+sort+'&topic='+topic+'&search='+product+'&limit='+max;
				
				symData.sym_name=topic;
				symData.url=url;
			}
			
			
			
			return symData;
		};
		function replaceHTMLHelpLibrary(isSolution, helpLibraryData) {
			var num = 0,
				html = '';

			if(typeof helpLibraryData == 'object') {
				if(helpLibraryData.flag=="Y") {
					var len = helpLibraryData.list.length;
					if(len>0) {
						if(len>max) len=max;
						for(i=0;i<len;i++) {
							html = html + '<li class="unit">';
							if (helpLibraryData.list[i].isVideo) html = html + '<div class="icon-wrapper"><span class="icon"><img src="/us/images/support/icons/shooting.svg" alt="Article embedded video icon"></span></div>';
							else html = html + '<div class="icon-wrapper"><span class="icon"><img src="/us/images/support/icons/document.svg" alt="General article icon"></span></div>';
							var isPick = helpLibraryData.list[i].itemtopflag;
							var pickHTML = (isPick=="Y") ? '<span class="recommendation">'+helpLibraryData.list[i].flagtext+'</span>':'';
							html = html + '<dl><dt><div class="eyebrow">'+xssfilter(helpLibraryData.list[i].eyebrow)+'</div><a href="'+xssfilter(helpLibraryData.list[i].linkURL)+'" data-link-area="cs_help_library_list_view_detail" data-link-name="'+xssfilter(helpLibraryData.list[i].adobeTitle)+'">'+pickHTML+xssfilter(helpLibraryData.list[i].title)+'</a></dt><dd>'+xssfilter(helpLibraryData.list[i].desciption)+'</dd></dl>';
							html = html + '</li>';
							num ++;
						}
						if(num>0) {
							cont.find('.unit-list').html(html);
							cont.find('.have-result').show();
							cont.find('.no-content').hide();
						} else {
							cont.find('.have-result').hide();
							cont.find('.no-content').show();
						}
					} else {
						// not yet
						cont.find('.have-result').hide();
						cont.find('.no-content').show();
					}
				}else if(helpLibraryData.flag=="N" && helpLibraryData.error.type == "downtime") {
					var $errorWrapper = cont.find('.error-common');

					$errorWrapper.find('.start-time').text(helpLibraryData.error.startTime);
					$errorWrapper.find('.end-time').text(helpLibraryData.error.endTime);

					cont.find('.have-result').hide();
					cont.find('.no-content').hide();
					cont.find('.error-common').show();
				}
			}
		}
		// PSP page for desktop
		cont.find('.tabs-menu-wrapper ul.menu-list li.menu a').on('click', function(event) {
			// click topic for desktop
			event.preventDefault();

			// change menu active
			/* PJTWAUS-6 20200205 modify */
			$(this).closest('ul.menu-list').find('.active').removeClass('active').find('a').attr('aria-selected', false);
			$(this).parent().addClass('active');
			$(this).attr('aria-selected', true);
			/*// PJTWAUS-6 20200205 modify */

			topic = $(this).data('topic');
			helpLibraryData = callHelpLibrary();
			var topicJson= {
					"topicBody":helpLibraryData.sym_name
			};
			
			//ajax.call(helpLibraryData, null, 'json', function(data){
			ajax.call(helpLibraryData.url, topicJson, 'json', function(data){
				replaceHTMLHelpLibrary(isSolution, data);
			});
		});
		// PSP page for mobile
		cont.find('.tabs-menu-wrapper div.menu-list select').change(function(event) {
			// change topic for mobile
			event.preventDefault();

			topic = $(this).val();
			helpLibraryData = callHelpLibrary();
			var topicJson= {
					"topicBody":helpLibraryData.sym_name
			};
			
			//ajax.call(helpLibraryData, null, 'json', function(data){
			ajax.call(helpLibraryData.url, topicJson, 'json', function(data){
			replaceHTMLHelpLibrary(isSolution, data);
			});
		});
		// Solutions page
		cont.find('.tabs-type-liner button.btn-tab').on('click', function() {
			// click sort button
			event.preventDefault();

			// change memu active
			/* PJTWAUS-1 : 20200203 modify */
			$(this).closest('.tabs-type-liner').find('button.btn-tab').removeClass('active').attr('aria-selected', false);
			$(this).addClass('active').attr('aria-selected', true);
			/*// PJTWAUS-1 : 20200203 modify */ 
			// data
			//topic = $(this).val();
			helpLibraryData = callHelpLibrary();
			var topicJson= {
					"topicBody":helpLibraryData.sym_name
			};
			//ajax.call(helpLibraryData, null, 'json', function(data){
			ajax.call(helpLibraryData.url, topicJson, 'json', function(data){
				replaceHTMLHelpLibrary(isSolution, data);
			});
		});
		/* PJTWAUS-1 : 20200311 add */
		$('div[id*=software_drivers_reference]').find('.mCSB_scrollTools').attr('tabindex', '0');
		/*// PJTWAUS-1 : 20200311 add */
	};
	supportHelpLibrary();
});